var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5859 12L12 10.5859L7.41407 5.99998L12 1.41405L10.5859 -6.18103e-08L6.00002 4.58593L1.41405 -4.62726e-07L-6.18103e-08 1.41405L4.58593 5.99998L-4.62725e-07 10.5859L1.41405 12L6.00002 7.41407L10.5859 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCross);
export default __webpack_public_path__ + "static/media/white-cross.371920c9a0d8ce2029c4555cfb164716.svg";
export { ForwardRef as ReactComponent };